var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.99978V9.90578C21.75 10.312 21.64 10.7107 21.4318 11.0595C21.2235 11.4082 20.9247 11.6941 20.567 11.8868L14.089 15.3748M2.25 8.99978V9.90578C2.24998 10.312 2.35995 10.7107 2.56824 11.0595C2.77652 11.4082 3.07534 11.6941 3.433 11.8868L9.911 15.3748M9.911 15.3748L10.933 14.8248C11.2609 14.6481 11.6275 14.5557 12 14.5557C12.3725 14.5557 12.7391 14.6481 13.067 14.8248L14.09 15.3748L18.75 17.8848M9.911 15.3748L5.25 17.8848M21.75 19.4998C21.75 20.0965 21.5129 20.6688 21.091 21.0908C20.669 21.5127 20.0967 21.7498 19.5 21.7498H4.5C3.90326 21.7498 3.33097 21.5127 2.90901 21.0908C2.48705 20.6688 2.25 20.0965 2.25 19.4998V8.84378C2.25016 8.43771 2.36022 8.03925 2.56849 7.69066C2.77677 7.34207 3.07549 7.05634 3.433 6.86378L10.933 2.82378C11.2609 2.64715 11.6275 2.55469 12 2.55469C12.3725 2.55469 12.7391 2.64715 13.067 2.82378L20.567 6.86378C20.9245 7.05634 21.2232 7.34207 21.4315 7.69066C21.6398 8.03925 21.7498 8.43771 21.75 8.84378V19.4998Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.9d57d53b5972deb35c986491f285d17d.svg";
export { ForwardRef as ReactComponent };